<style src="./style.scss">
</style>

<div class="card"><slot /></div>
